// extracted by mini-css-extract-plugin
export default {"productGallery":"JN-z","inQuickShop":"KN-z"};